// Common to Main and Distribution App
// Add polyfills and generally all configuration that should be the same in both parts of the app.

import "material-design-icons-iconfont/dist/material-design-icons.css";
import "typeface-nunito/index.css";
import "typeface-open-sans/index.css";
import "@js-joda/timezone";
import "@/plugins/validation";
import "@/plugins/portalVue";
import "@/plugins/signaturePad";

import { i18n } from "@/plugins/i18n";
import Vue from "vue";
import environment from "@/environment";
import { setRoot } from "@/components/composables/root";

Vue.config.productionTip = false;
Vue.config.devtools = true;
Vue.config.performance = environment.isDevelopment;

export { Vue, i18n, setRoot, environment };
